import axios, { AxiosResponse } from 'axios'

// Valid PC error fields:
// - code / _code: the PC-XXX-XXX error code
// - message / _message: the actual error message
// - fault / _fault: Whether a PC service was responsible for the error
// - inputs / _inputs: The array of inputs that have an error.
export const getPCErrorField = (error: unknown, field: string): any | undefined => {
  const errData = getAxiosErrData(error)
  if (!errData) {
    return
  }

  let underscored = field
  let nonunderscored = field
  if (field.indexOf('_') === 0) {
    nonunderscored = field.replace('_', '')
  } else {
    underscored = `_${field}`
  }

  if (errData.hasOwnProperty(underscored)) {
    return errData[underscored]
  }

  if (errData.hasOwnProperty(nonunderscored)) {
    return errData[nonunderscored]
  }

  if (errData[nonunderscored]) {
    return errData[nonunderscored]
  }

  return
}

export const getAxiosErrResponse = (error: unknown): AxiosResponse | undefined => {
  if (!axios.isAxiosError(error)) {
    return
  }

  if (!error.response) {
    return
  }

  return error.response
}

const getAxiosErrData = (error: unknown): any | undefined => {
  const errResp = getAxiosErrResponse(error)
  if (!errResp) {
    return
  }

  if (!errResp.data) {
    return
  }

  return errResp.data
}
